import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import { currencyFormatter, financial, ProductName } from '@lendica/utils';
import { FundNowLogo, PayLaterLogo, DrawDownLogo } from '@lendica/components';

export const FundsAvailableCard = ({ approvals }) => {
    return (
        <Box
            sx={theme => ({
                borderRadius: '8px',
                border: `1px solid ${theme.palette.primary.main}`,
                background: `${theme.palette.background.cardLight}`,
                color: `${theme.palette.primary.main}`,
            })}
        >
            {approvals.map((approval, index) => (
                <Box key={approval.id}>
                    {index > 0 && <Divider sx={{ margin: '0 16px' }} />}
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            padding: '12px 16px',
                            color: 'inherit',
                        }}
                    >
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                            }}
                        >
                            {approval.product_name === ProductName.FundNow && <FundNowLogo />}
                            {approval.product_name === ProductName.PayLater && <PayLaterLogo />}
                            {approval.product_name === ProductName.DrawDown && <DrawDownLogo />}
                        </Box>
                        <Typography
                            sx={{
                                color: 'inherit',
                                fontFeatureSettings: "'clig' off, 'liga' off",
                                fontSize: '24px',
                                fontWeight: 800,
                            }}
                        >
                            {currencyFormatter(financial(approval.funds_available))}
                        </Typography>
                    </Box>
                </Box>
            ))}
        </Box>
    );
};
